import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CheckCircle } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { fetchMeta } from "../../actions/metaActions";
import { Helmet } from "react-helmet-async";
import "./SuccessPage.css";

export default function SuccessPage() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { meta, loading: metaLoading } = useSelector((state) => state.metaState);

    useEffect(() => {
        dispatch(fetchMeta('order-success'));
    }, [dispatch]);

    return (
        <>
            <Helmet>
                <title>{meta?.title}</title>
                <meta name="description" content={meta?.metaDescription} />
                <meta name="keywords" content={meta?.keywords} />
                <link rel="canonical" href={meta?.canonicalUrl} />
                <meta name="robots" content={meta?.robots} />
            </Helmet>

            <div className="d-flex flex-column justify-content-center align-items-center">
                <div className="empty-cart text-center py-5">
                    <div className="success-card">
                        <CheckCircle className="success-icon" />
                        <h2 className="success-title">Order Successful!</h2>
                        <p className="success-message">
                            Thank you for your order. Our team will contact you soon.
                        </p>
                        <button
                            className="success-btn"
                            onClick={() => navigate("/")}
                        >
                            Continue Shopping
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
}
